import axios from 'axios';

export const instance = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
});

export const monitorsInstance = axios.create({
  baseURL: process.env.REACT_APP_UPTIMEROBOT_API_URL,
});
